import React, { Suspense } from 'react';

import { useSelector } from 'react-redux';
import { ExcelsiorOverlay } from './ExcelsiorOverlay';
import { ExcelsiorCartMenu } from './purchase/ExcelsiorCartMenu';
import { HOME, LIBRARY, DETAILS, PURCHASING, UPLOADING, READING, LOADING } from './store/stageSlice'
import ExcelsiorErrorBoundary from './ExcelsiorErrorBoundary'
import {motion} from 'framer-motion'
import './Excelsior.css'

const ExcelsiorReader = React.lazy(() => import('./ExcelsiorReader').then(module => ({ default: module.ExcelsiorReader })));
const ExcelsiorHome = React.lazy(() => import('./ExcelsiorHome').then(module => ({ default: module.ExcelsiorHome })));
const ExcelsiorLibrary = React.lazy(() => import('./ExcelsiorLibrary').then(module => ({ default: module.ExcelsiorLibrary })));
const ExcelsiorBookDetail = React.lazy(() => import('./ExcelsiorBookDetail').then(module => ({ default: module.ExcelsiorBookDetail })));


export function ExcelsiorMain() {
  
    const stageState = useSelector(state => state.stage);
    const isCartOpen = useSelector((state) => state.cart.isCartOpen);

    const content = (

        <motion.div 
        key={stageState.mainStage}       
         initial={stageState.mainStage === HOME ? {opacity:0} : {opacity: 0, scale: 0.9, y:"10%"}}
        animate={{opacity: 1, scale: 1, y:0}}
        >
          {getComponentBasedOnState(stageState.mainStage)}
        </motion.div>

    );


    const overlay = (stageState.overlayStage === LOADING || stageState.overlayStage === UPLOADING) ? <ExcelsiorOverlay isMinimal={stageState.isMinimal} /> : null;
    const cartMenu = isCartOpen ? <ExcelsiorCartMenu /> : null;


    return (
      <ExcelsiorErrorBoundary>
      <Suspense fallback={overlay}>
        {content}
        {cartMenu}
        {overlay}
        </Suspense>
      </ExcelsiorErrorBoundary>
    );
}

function getComponentBasedOnState(stage) {
  switch(stage) {
    case HOME:
      return <ExcelsiorHome/>
    case DETAILS:
      return <ExcelsiorBookDetail/>
    case LIBRARY:
      return <ExcelsiorLibrary/>
    case PURCHASING:
    case READING:
      return <ExcelsiorReader/>
    default:
      return <div>Unknown stage</div>;
  }

  
}
